import { render } from "./NotificationsHome.vue?vue&type=template&id=465af6a4&scoped=true"
import script from "./NotificationsHome.vue?vue&type=script&lang=js"
export * from "./NotificationsHome.vue?vue&type=script&lang=js"

import "./NotificationsHome.vue?vue&type=style&index=0&id=465af6a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465af6a4"]])

export default __exports__